import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'

/**
 * Advantage+ leads state of a campaign with one campaign budget, as Meta reported it after publishing, with why the
 * results of its ad sets are not a fair split. Nothing for other campaigns.
 */
const AdvantageLeadsNote = ({ advantageLeads }) => {
    if (!advantageLeads) return null
    const colour =
        advantageLeads.on === true
            ? 'tw:text-green-400'
            : advantageLeads.on === false
              ? 'tw:text-yellow-300'
              : 'tw:text-gray-200'

    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <span
                    className={`tw:shrink-0 tw:text-xs tw:rounded tw:border tw:px-1.5 tw:py-0.5 ${colour}`}
                    data-testid="advantage-leads-note"
                >
                    {advantageLeads.label}
                </span>
            </TooltipTrigger>
            <TooltipContent className="tw:max-w-80">
                <span className="tw:whitespace-pre-line">{advantageLeads.note}</span>
            </TooltipContent>
        </Tooltip>
    )
}

export default AdvantageLeadsNote
